import React, { useEffect, useState } from 'react';
import { useAppContext } from '/@contexts/global-app-context';
import { useGetTeamsRowUsageStats } from '/@services/teams/teams-service';
import { useGetNumUsersInOrg } from '/@services/trial/trial-service';
import { UserAndDataUsageBanner } from './user-and-data-usage-banner';

export interface UserAndDataUsageBannerContainerProps {
    showUserLimitBanner?: boolean;
    showDataUsageBanner?: boolean;
}

export const UserAndDataUsageBannerContainer: React.FC<UserAndDataUsageBannerContainerProps> = ({
    showUserLimitBanner,
    showDataUsageBanner,
}) => {
    const { sessionService, metricsService, navService } = useAppContext();
    const [percent, setPercent] = React.useState<number>();
    const releaseVersion = sessionService.getReleaseVersion();
    const reduceRowDocUrl = `https://docs.thoughtspot.com/cloud/${releaseVersion}/row-count-reduce`;

    const { data, loading } = useGetTeamsRowUsageStats(0);

    React.useEffect(() => {
        if (data) {
            setPercent(Math.floor((data.totalRowCount * 100) / data.rowLimit));
        }
    }, [loading, !!data]);

    const {
        data: memberDetails,
        loading: memberDetailsLoading,
        refetch: updateMemberDetails,
    } = useGetNumUsersInOrg();

    const callback = () => {
        updateMemberDetails();
    };

    useEffect(() => {
        sessionService.globalBannerObserverSubscriber(callback);
        return () => {
            sessionService.unsubscribeGlobalBannerObserver();
        };
    }, []);

    useEffect(() => {
        if (memberDetails) {
            localStorage.setItem(
                'numUsersInOrg',
                memberDetails.getMembersDetails?.numUsersInOrg?.toString(),
            );
        }
    }, [memberDetailsLoading, memberDetails?.getMembersDetails?.numUsersInOrg]);

    const memberLimit =
        sessionService.getTeamsConfig() &&
        sessionService.getTeamsConfig().maxUserInTeamEditionOrg
            ? sessionService.getTeamsConfig().maxUserInTeamEditionOrg
            : 5;

    if (
        (percent && percent >= 100 && showDataUsageBanner) ||
        (memberDetails?.getMembersDetails?.numUsersInOrg > memberLimit &&
            showUserLimitBanner)
    ) {
        return (
            <UserAndDataUsageBanner
                percent={percent}
                reduceRowDocUrl={reduceRowDocUrl}
                isOwner={sessionService.getIsTeamEditionOwner()}
                collectEvent={metricsService?.collectEvent}
                goToTeamsPage={navService?.goToTeamsPlanOptions}
                goToAdmin={navService?.goToAdmin}
                numUsersInOrg={memberDetails?.getMembersDetails?.numUsersInOrg}
                rowLimit={data?.rowLimit}
                currentUsage={data?.totalRowCount}
                memberLimit={memberLimit}
                showUserLimitBanner={showUserLimitBanner}
                showDataUsageBanner={showDataUsageBanner}
            />
        );
    }

    return <></>;
};
